export class UserAclAuthorities {
  constructor(
    public userLogin: string,
    public aclAuthorities: Array<string>,
  ) { }
}
